module.exports = {
  name: "Saffron Files",
  iconPaths: {
    favicon32: "saffronfiles/images/favicons/favicon-32x32.png",
    favicon16: "saffronfiles/images/favicons/favicon-16x16.png",
    appleTouchIcon: "saffronfiles/images/favicons/apple-touch-icon-152x152.png",
    maskIcon: "saffronfiles/images/favicons/safari-pinned-tab.svg",
    msTileImage: "saffronfiles/images/favicons/msapplication-icon-144x144.png",
  },
  themeColor: "#4d3791",
};
